import { motion } from "framer-motion";
import { ThreeDot } from "react-loading-indicators";

const Loading = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">

        {/* Logo / Brand */}
        <motion.img
          src="/logo.png"
          alt="Loading"
          className="w-40 h-40 object-contain"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: "easeOut",
          }}
        />

        <ThreeDot color={["#4c0e10", "#781519", "#a31d22", "#ce252b"]} />
      </div>
    </div>
  );
};

export default Loading;